import { useMemo } from "react";
import type { Company } from "src/api/client-api/company/useGetOneOrganization.ts";

export const useCompanyValidation = (company: Company | undefined) => {
    const requiredMissing = useMemo(
        () =>
            !(
                (company?.name ?? "").trim() &&
                (company?.email ?? "").trim() &&
                (company?.country ?? "").trim() &&
                (company?.zipcode ?? "").trim()
            ),
        [company],
    );

    return { requiredMissing };
};
